import moment from "moment";
import apiClient from "../../../apiClient";
import { fileDownload } from "../../../utils";
import { Button } from "reactstrap";

export default function EmployeeSLA () {

    const downloadData = async () => {
        try {
            const res = await apiClient.get(`/dev/employee-sla`);
            fileDownload(res.data, `Employee SLA ${moment().format('YYYY-MM-DD-hh-mm')}.csv`);
        } catch (err) {
            alert(err);
        }
    }

    return (
        <div>
            <Button onClick={downloadData}>Download Data</Button>
        </div>
    );
}